import { apiCall, http } from '../http'
import type { WidgetStatusResponse } from './types'

/**
 * Получить статус виджета
 */
export async function getStatus(params: { projectId: string }) {
    const url = `messenger/widget/status`
    const { data, error } = await apiCall<WidgetStatusResponse>(() =>
        http.get(url, {
            searchParams: {
                projectId: params.projectId,
            },
        })
    )
    return { data, error }
}

/**
 * Инициализировать виджет
 */
export async function init(params: { projectId: string }) {
    const url = `messenger/widget/init`
    const { data, error } = await apiCall<{ message: string }>(() =>
        http.post(url, {
            json: {
                projectId: params.projectId,
            },
        })
    )
    return { data, error }
}